import * as Yup from 'yup'

export const messageValidation = Yup.object().shape({
  subject: Yup.string().required().label('Subject'),
  body: Yup.string().required().label('Body'),
})
